/* eslint-disable react/jsx-no-comment-textnodes */
import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import { CModal, ModalOverlay, ModalContent, ModalCloseButton } from '@televet/kibble-ui';
import { IAvailableKeyboardShortcuts } from '../../../interfaces/IKeyboardShortcutElementRefs';

export const availableKeyboardShortcuts: IAvailableKeyboardShortcuts[] = [
  {
    char: 'a',
    name: 'Attach File',
  },
  {
    char: 'e',
    name: 'Insert Emoji',
  },
  {
    char: 'f',
    name: 'Attach Form',
  },
  {
    char: 'g',
    name: 'Insert GIF',
  },
  {
    char: 'i',
    name: 'Attach Invoice',
  },
  {
    char: 't',
    name: 'Insert Message Template',
  },
  {
    char: 'h',
    name: 'List of Available Shortcuts',
  },
];

interface IModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MessageComposerKeyboardShortcutHelpModal = ({ isOpen, onClose }: IModalProps): ReactElement => {
  return (
    <CModal size="lg" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalContainer>
          <Header>How to Use Keyboard Shortcuts</Header>
          <Instructions>
            Shortcut commands trigger an action from the message composer toolbar using only your keyboard. To use, type
            two forward slashes <InlineCodeBlock>//</InlineCodeBlock> followed immediately by one of the listed
            supported characters and then press <InlineCodeBlock>Enter</InlineCodeBlock> to proceed.
          </Instructions>
          <UserTable>
            <thead>
              <tr>
                <th>Shortcut Name</th>
                <th>Toolbar Action</th>
              </tr>
            </thead>
            <tbody>
              {availableKeyboardShortcuts.map((hotkeyItem) => {
                return (
                  <tr key={hotkeyItem.char}>
                    <td>
                      <InlineCodeBlock>//{hotkeyItem.char}</InlineCodeBlock>
                    </td>
                    <td>{hotkeyItem.name}</td>
                  </tr>
                );
              })}
            </tbody>
          </UserTable>
        </ModalContainer>
      </ModalContent>
    </CModal>
  );
};

export default MessageComposerKeyboardShortcutHelpModal;

const ModalContainer = styled.div`
  padding: 0 20px;
`;

const Header = styled.h1`
  color: #000b8e;
  padding: 20px 0 15px;
  font-size: 20px;
  font-weight: 600;
`;

const UserTable = styled.table`
  width: 100%;
  text-align: left;
  vertical-align: middle;
  margin-bottom: 30px;
  border-collapse: collapse;
  border: 1px solid #e8e9e9;

  th {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: bold;
    padding: 5px 10px;
    border: 1px solid #e8e9e9;
  }

  td {
    padding: 15px 10px;
    font-size: 14px;
    border: 1px solid #e8e9e9;
  }

  thead tr {
    border-bottom: 1px solid #e8e9e9;
  }

  tbody tr:nth-of-type(2n) {
    background: #f1f5f6;
  }
`;

const InlineCodeBlock = styled.code`
  background: #f7f7f7;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 0 5px;
  margin: 0 2px;
  font-size: 14px;
`;

const Instructions = styled.p`
  margin-bottom: 30px;
  line-height: 1.5;
`;
